import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routeList } from "../../Routes.tsx";
import { TitleProps } from "./TitleProps.tsx";

const Title: React.FC<TitleProps> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      return;
    }

    // Check for exact match first
    const exactRoute = routeList.find(
      (route) => route.path === location.pathname,
    );

    if (exactRoute) {
      document.title = exactRoute.title;
      return;
    }

    // Fallback
    document.title = "Earthbound Martian";
  }, [location, title]);

  return null;
};

export default Title;
